import type { ReactNode } from 'react';

import type { TBulletedListElement } from '@shared/dream-components';
import { BulletedListElement } from '@shared/dream-components';

interface Props {
  node: TBulletedListElement;
  children: ReactNode | ReactNode[];
}

export const BulletedList = ({ node, children }: Props) => {
  return <BulletedListElement element={node}>{children}</BulletedListElement>;
};
